module.exports = __webpack_public_path__ + "static/hero-about-f032f8d2836d0e4df95fc1290cca18c6.png";